import {isNull,isObj} from '@/libs/basics-tools'

export const callApp = (appFnName,data)=>{
    if (window.ImLawApp){
      try {
        if(isNull(data)){
          window.ImLawApp[appFnName]();
        }else if(isObj(data)){
          window.ImLawApp[appFnName](JSON.stringify(data));
        }else{
          window.ImLawApp[appFnName](data.toString());
        }
      } catch (e) {
        console.log(`APP接口错误：${e}`);
        return Promise.reject();
      }
      return Promise.resolve();
    } else {
        try{
          window.webkit.messageHandlers[appFnName].postMessage(isNull(data) ? JSON.stringify(data) : data);
          return Promise.resolve();
        }catch(e){
          return Promise.reject();
        }
    }
}